import { initStore } from '../StoreService';

const configureSuccessfulApiStore = () => {
    const actions = {
        SUCCESSFUL_REQUEST: (state, success) => ({ ...state, isSuccess: success }),
    };
    initStore(actions, { isSuccess: false });
};

export default configureSuccessfulApiStore;